<template>
  <div style="width:100%; height: 100%;overflow:scroll;">
    <div class="ls">
      <div class="eti">欠款顾客列表
      </div>
    </div>
      <div style="margin: 15px 15px 30px 15px;width: 300px">
        <el-input placeholder="姓名 / 手机号" v-model="mpName" size="mini" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="getMemberArrearsList()"></el-button>
        </el-input>
      </div>
      <div class="del-dialog-cnt">
        <el-table :data="list" size="small" style="width: 100%;overflow: auto;">
          <el-table-column prop="memberName"  label="顾客姓名" />
          <el-table-column prop="phone"  label="手机号码" />
          <el-table-column prop="amount"  label="欠款总金额" />
          <el-table-column prop="createTime" label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="toDetailed(scope.row)" >查看明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :pager-count="7"
            layout="total, prev, pager, next"
            :total="pagination.count"
            :page-count="pagination.pageCount"
            :current-page="pagination.pageNumber"
          ></el-pagination>
        </div>
      </div>

    <Qkinfo
      v-if="mxVisible"
      :mxVisible="mxVisible"
      :mxList="mxList"
      :memberId="memberId"
      @closeQk="closeQk"
      @successQk="successQk"
    />
  </div>
</template>

<script>
  import Qkinfo from "./qkinfo";
  import {getToken} from "../../../utils/auth";

  export default {
    name: "haikuan",
    components: {
      Qkinfo,
    },
    data() {
      return {
        mpName: "",
        memberId: "",
        member:{},
        list: [],
        pagination: {
          count: 0,
          pageNumber: 0,
          pageSize: 0,
          pages: 1
        },

        mxVisible:false,
        mxList:[],
      };
    },
    async created() {
      this.getMemberArrearsList()
    },

    methods: {
      async toDetailed(item) {
        this.memberId=''
        if (!item.memberId){
          return ;
        }
        this.memberId=item.memberId
        let data = {
          memberId: item.memberId,
          token: getToken(),
        };
        let res = await this.$get("/sw/getMaInfos", data);
        if (res.list.length>0){
          this.mxList = res.list;
          this.mxVisible = true
        }
      },
      closeQk(){
        this.mxVisible = false
      },
      successQk(){
        this.mxVisible = false
        this.getMemberArrearsList()
      },

      handleCurrentChange(page) {
        this.getMemberArrearsList(page)
      },

      async getMemberArrearsList(page) {
        let currentPage = page || 1;
        let data = {
          mpName: this.mpName,
          token:getToken(),
          currentPage
        };
        let res = await this.$get("/sw/getMemberArrearsList", data);
        this.list = res.dataSet.list;
        this.pagination = {
          count: res.dataSet.count,
          pageNumber: res.dataSet.pageNumber,
          pageSize: res.dataSet.pageSize,
          pageCount: res.dataSet.pages
        }
      },
    },
  };
</script>


<style lang="scss" scoped>
  .ls {
    width: 100%;
    padding: 0 15px;
    background: #fff;
    border-bottom: #e4e4e4 solid 1px;
  }

  .ls .eti {
    display: block;
    color: #1e1e1e;
    font-size: 14px;
    font-weight: 700;
    line-height: 45px;
    text-align: center;
  }
  .del-dialog-cnt{
    width: 95%;
    margin: auto;
  }

</style>
